export function isNotNull<T>(v: T): v is Exclude<T, null | undefined> {
    return v != null;
}
